import xlsx from 'json-as-xlsx'
import moment from 'moment'
import {
  getUserBulkResults,
  UserBulkRowResult
} from '@/components/doctors/doctors.service'

export function writeUserUploadResults(rows: UserBulkRowResult[]) {
  xlsx(
    [
      {
        sheet: 'Results',
        columns: [
          { label: 'Row', value: 'row' },
          { label: 'DocumentID', value: 'documentId' },
          { label: 'FirstName', value: 'firstName' },
          { label: 'LastName', value: 'lastName' },
          { label: 'Role', value: 'role' },
          { label: 'Result', value: 'result' },
          { label: 'Error', value: 'error' }
        ],
        content: rows
      }
    ],
    {
      fileName: `users-upload-results-${moment().format('YYYY-MM-DD-HHmm')}`,
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false
    }
  )
}

export async function downloadUserUploadResults(uploadId: string) {
  const rows = await getUserBulkResults(uploadId)
  writeUserUploadResults(rows)
}
